let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5nn7A")).then(() => parcelRequire('g9psZ'));